<template>
  <div class="form-group required">
    <ValidationProvider tag="div"
                        class="form-field field-textfield"
                        :class="{ required: isRequired } + ' ' + activeField"
                        :rules="rules"
                        :immediate="!!value"
                        v-slot="{ classes, errors }">
        <div v-if="errors[0]" class="invalid-feedback">{{ errors[0] }}</div>
        <label v-if="label" :for="'textfield-' + _uid" class="control-label">{{ label }}</label>
        <input :type="inputType"
               :id="'textfield-' + _uid"
               class="form-control"
               :class="classes"
               :value="value"
               :placeholder="placeholder"
               :autocomplete="autocomplete"
               :required="required"
               :pattern="pattern"
               :maxlength="maxlength"
               :inputmode="inputmode"
               :disabled="disabled"
               :min="min"
               :max="max"
               @keyup="inputFocusHandler($event)"
               @blur="$emit('blur')"
               @input="$emit('input', $event.target.value)">
        <slot/>
    </ValidationProvider>
  </div>
</template>

<script>
import BaseField from './BaseField'

export default {
    name: 'TextField',
    extends: BaseField,
    data: () => ({
        activeField: false
    }),
    props: {
        inputType: {
            type: String,
            default: 'text'
        },
        label: String,
        disabled: Boolean,
        placeholder: String,
        autocomplete: String,
        pattern: String,
        maxlength: String,
        inputmode: String,
        min: String,
        max: String
    },
    methods: {
        inputFocusHandler(event) {
            this.activeField = (event.target.value !== '') ? 'active' : ''
        }
    },
    mounted() {
        this.activeField = (this.value !== '') ? 'active' : ''
    }
}
</script>
